import { z } from 'zod';

export const NotificationPendingCountsResponseSchema = z.object({
  // * null means the caller lacks permission for that feature;
  // * 0 means permission is granted but nothing is pending.
  trainAiPendingCount: z.number().nullable(),
  knowledgeArticlePendingCount: z.number().nullable(),
});
